import { Component, Input, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../services';
import { CoreImageUploadComponent } from '../core-image-upload/core-image-upload.component';
import { CoreImageListComponent } from '../core-image-list/core-image-list.component';

/**
 * Self-contained modal: shows an entity's images (with open-full/delete) and
 * lets the user upload more, immediately, without any wiring from the caller.
 * Usage: bsModalService.show(EntityImagesModalComponent, { initialState: { entityType, entityId, title } })
 */
@Component({
  selector: 'app-entity-images-modal',
  templateUrl: './entity-images-modal.component.html'
})
export class EntityImagesModalComponent {
  @Input() entityType = '';
  @Input() entityId = 0;
  @Input() title = '';

  @ViewChild(CoreImageUploadComponent)
  uploadComp?: CoreImageUploadComponent;
  @ViewChild(CoreImageListComponent) listComp!: CoreImageListComponent;

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: ToasterService
  ) {}

  upload(): void {
    this.uploadComp?.uploadImages(this.entityType, this.entityId);
  }

  onImagesUploaded(event: any): void {
    if (event.status !== 'success') {
      this.toastr.showError('messages.images_upload_error');
      return;
    }
    if (event?.data?.length > 0) {
      this.toastr.showSuccess('messages.images_upload_success');
      this.listComp?.reload();
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
